import styled from 'styled-components';
import { Button } from '@clds/button';
import { globalTheme } from '@clds/component-theme';
import { Tooltip } from '@clds/tooltip';

const StyledButton = styled(Button)`
  margin: -${(props) => props.theme.spacing.xs};
`;

export const SideMenuTooltipButton: React.FC<{
  tooltip: string;
  icon: React.ReactNode;
  action: () => void;
}> = ({ tooltip, icon, action }) => {
  const handleAction = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    action();
  };

  return (
    <Tooltip title={tooltip} trigger={'hover'} placement={'top'} overlayClassName="non-clickable-tooltip">
      <StyledButton leftSlot={icon} onClick={handleAction} variant={'secondary'} tone="plain" size="sm" />
    </Tooltip>
  );
};
